<template>
  <div class="login-container">
    <!-- <img src="../assets/Hero_picture.png" height="100%"> -->
    <div class="login_box">
      <br>
      <!-- <span style="font-size: 10px; color: red;  padding-top:50px; padding:15px;">
      * Enjoy 24/7 access to our web portal to check your project status updates and on going order status
      </span> -->
      <span style="padding-top:50px; padding:26px;">
      Enjoy 24/7 access to our web portal to check your project
      </span>
      <span  style="padding-top:50px; padding:26px;">
      status updates and on going order status
      </span>
      <div class="avatar_line">
Please login to your account below :
      </div>
      <!--  height="100%"  width="100%"<div class="avatar_box">
        <img src="../assets/logo.png" alt="">
      </div> -->
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form">
        <!--用户-->
        <br>
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-s-check"></el-input>
        </el-form-item>
        <!--密码-->
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-s-cooperation" type="password"></el-input>
        </el-form-item>
        <!--按钮-->
        <div align="center">
        <el-form-item class="btns" style="align: center">
           <el-button type="primary" @click="login">Ok</el-button>
           <el-button type="info" @click="resetLoginForm">Reset</el-button>
        </el-form-item>
        </div>
      </el-form>
    </div>
  </div>

</template>

<script>
// import { requestLogin } from '../api/api';
export default {
  data () {
    /* var checkPassword = (rule, value, callback) => {
      var regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}');
      if (!regex.test(value)) {
        return callback(new Error('您的密码复杂度太低（密码中必须包含字母、数字、特殊字符），请及时改密码！'));
        } else {
          callback();
        }
            if (!value) {
              return callback(new Error('年龄不能为空'));
            }
            setTimeout(() => {
              if (!Number.isInteger(value)) {
                callback(new Error('请输入数字值'));
              } else {
                if (value < 18) {
                  callback(new Error('必须年满18岁'));
                } else {
                  callback();
                }
              }
            }, 1000);
          };
 */
    return {
      // 这是登录表单的数据绑定对象
      loginForm: {
      //  username: 'aaa',
      //  password: '123456'
      },
      loginFormRules: {
        username: [
          { required: true, message: 'Please input the user name', trigger: 'blur' },
          { min: 2, max: 10, message: 'The length is between 3 and 10', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please input the password', trigger: 'blur' },
          { min: 6, max: 20, message: 'The length is between 6 and 20', trigger: 'blur' }
          // { validator: checkPassword, trigger: 'blur' }
        ]
      }
      // resetLoginForm: {}
    }
  },
  methods: {
    resetLoginForm () {
      // console.log (this);
      this.$refs.loginFormRef.resetFields()
    },
    login () {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return
        // console.log(valid){
        // console.log(this.loginForm)
        const { data: res } = await this.$http.post('userManagement/login', this.loginForm)
        if (res.code !== 200) return this.$message.error('Logon failor')
        this.$message.success('Logon successfully')
        // console.log(res)
        window.sessionStorage.setItem('loginname', this.loginForm.username)
        window.sessionStorage.setItem('username', res.org)
        window.sessionStorage.setItem('token', res.token)
        window.sessionStorage.setItem('userType', res.userType)

        this.$router.push('/home')
        // const { data: res } = await this.$http.get('login', { username: this.loginForm.username, password: this.loginForm.password })
        // if (res.code !== 200) return console.log('failer')
        // console.log('successful')
      })
    }
  }
}

</script>

<style lang="less" scoped="scoped">
  .login-container{
    background-color: rgb(213,170,170);
    background: #000 url(../assets/Hero_picture.png) no-repeat fixed center center;
    background-size: cover;
    // background-color: #2b4b6b;
    height:100%;
  }

  .login_box {
    width:450px;
    height:300px;
    background-color: #fff;
    border-radius: 3px;
    position: absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
    .avatar_line {
      top:19%;
      height:130px;
      // width:160px;
      // border:1px solid #eee;
      // border-radius:50%;
      padding:10px;
      position: absolute;
      left:5%;
      // transform: translate(-50%,-50%);
      background-color:#fff;
    }

    // .avatar_box {
    //   height:130px;
    //   width:130px;
    //   border:1px solid #eee;
    //   border-radius:50%;
    //   padding:10px;
    //   box-shadow: 0 0 10px #ddd;
    //   position: absolute;
    //   left:50%;
    //   transform: translate(-50%,-50%);
    //   background-color:#fff;
    //   img {
    //     width:100%;
    //     height:100%;
    //     border-radius:50%;
    //     background-color:#eee;
    //   }
    // }
  }

  .login_form{
    position: absolute;
    bottom:0;
    height:70%;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    opacity: abs(100);
  }
  .btns {
    display: flex;
    justify-content: flex-end;
  }
</style>
